// extracted by mini-css-extract-plugin
export var bubble = "_z-0";
export var container = "_z-f";
export var contrastBorder = "_z-g";
export var greyOut = "_z-2";
export var initialsColor0 = "_z-3";
export var initialsColor1 = "_z-4";
export var initialsColor10 = "_z-d";
export var initialsColor11 = "_z-e";
export var initialsColor2 = "_z-5";
export var initialsColor3 = "_z-6";
export var initialsColor4 = "_z-7";
export var initialsColor5 = "_z-8";
export var initialsColor6 = "_z-9";
export var initialsColor7 = "_z-a";
export var initialsColor8 = "_z-b";
export var initialsColor9 = "_z-c";
export var initialsWrapper = "_z-1";
export var large = "_z-l";
export var medium = "_z-k";
export var mediumSmall = "_z-j";
export var mediumSmallMedium = "_z-o";
export var micro = "_z-h";
export var small = "_z-i";
export var tiny = "_z-n";
export var xTiny = "_z-m";